import { Component } from 'react';
import { withRouter } from 'react-router';
import { withSteps } from 'Common/StepComponent';

import { VendorLinkConfigurationStep } from './components/VendorLinkConfigurationStep/VendorLinkConfigurationStep';
import { VendorLinkMappingStep } from './components/VendorLinkMappingStep/VendorLinkMappingStep';
import { VendorLinkPreviewStep } from './components/VendorLinkPreviewStep/VendorLinkPreviewStep';
import { VendorLinkImportStep } from './components/VendorLinkImportStep/VendorLinkImportStep';

export class VendorLinkIntegrationContainer extends Component {
  static title = 'VendorLink Integration';

  render() {
    return null;
  }
}

export const VendorLinkIntegration = withRouter(
  withSteps([
    VendorLinkConfigurationStep,
    VendorLinkMappingStep,
    VendorLinkPreviewStep,
    VendorLinkImportStep,
  ])(VendorLinkIntegrationContainer)
);



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/VendorLinkIntegration.js